import { useNavigate } from "react-router-dom";
import { articles } from "@/mocks/articles";

const articleImageUrls: Record<number, string> = {
  1: "https://readdy.ai/api/search-image?query=Fashion%20items%20flat%20lay%20with%20laptop%20and%20coffee%20on%20light%20sage%20green%20desk%2C%20soft%20morning%20light%2C%20editorial%20photography%2C%20modern%20workspace%20aesthetic%2C%20organic%20composition%2C%20subtle%20shadows%2C%20creative%20atmosphere&width=600&height=400&seq=kako-blog-01&orientation=landscape",
  2: "https://readdy.ai/api/search-image?query=Person%20typing%20on%20laptop%20with%20shopping%20list%20and%20fashion%20magazine%20on%20light%20terracotta%20desk%2C%20warm%20studio%20light%2C%20editorial%20photography%2C%20organized%20creative%20workspace%2C%20modern%20European%20aesthetic&width=600&height=400&seq=kako-blog-02&orientation=landscape",
  3: "https://readdy.ai/api/search-image?query=Collection%20of%20diverse%20fashion%20items%20arranged%20on%20light%20lavender%20surface%2C%20soft%20diffused%20lighting%2C%20editorial%20product%20photography%2C%20modern%20minimal%20aesthetic%2C%20harmonious%20colors%2C%20clean%20composition&width=600&height=400&seq=kako-blog-03&orientation=landscape",
  4: "https://readdy.ai/api/search-image?query=Shield%20security%20concept%20with%20shopping%20bags%20on%20light%20sand%20surface%2C%20soft%20studio%20lighting%2C%20editorial%20photography%2C%20trust%20and%20safety%20theme%2C%20minimal%20composition%2C%20warm%20reassuring%20aesthetic&width=600&height=400&seq=kako-blog-04&orientation=landscape",
  5: "https://readdy.ai/api/search-image?query=Happy%20person%20unboxing%20package%20on%20light%20peach%20background%2C%20warm%20natural%20lighting%2C%20editorial%20lifestyle%20photography%2C%20authentic%20joyful%20expression%2C%20modern%20European%20aesthetic%2C%20soft%20shadows&width=600&height=400&seq=kako-blog-05&orientation=landscape",
  6: "https://readdy.ai/api/search-image?query=Shipping%20box%20with%20packing%20materials%20on%20light%20mint%20green%20surface%2C%20soft%20studio%20lighting%2C%20editorial%20product%20photography%2C%20delivery%20concept%2C%20minimal%20composition%2C%20clean%20fresh%20aesthetic&width=600&height=400&seq=kako-blog-06&orientation=landscape",
  7: "https://readdy.ai/api/search-image?query=Magnifying%20glass%20over%20product%20images%20on%20light%20blush%20pink%20surface%2C%20soft%20studio%20lighting%2C%20editorial%20photography%2C%20fraud%20prevention%20concept%2C%20minimal%20composition%2C%20clean%20professional%20look&width=600&height=400&seq=kako-blog-07&orientation=landscape",
  8: "https://readdy.ai/api/search-image?query=Split%20comparison%20with%20two%20shopping%20carts%20on%20light%20dusty%20rose%20surface%2C%20soft%20studio%20lighting%2C%20editorial%20photography%2C%20versus%20competition%20theme%2C%20minimal%20balanced%20composition&width=600&height=400&seq=kako-blog-08&orientation=landscape",
  9: "https://readdy.ai/api/search-image?query=Open%20notebook%20with%20handwritten%20notes%20and%20fashion%20items%20on%20light%20oatmeal%20surface%2C%20soft%20warm%20lighting%2C%20editorial%20lifestyle%20photography%2C%20learning%20beginners%20concept%2C%20minimal%20composition%2C%20cozy%20atmosphere&width=600&height=400&seq=kako-blog-09&orientation=landscape",
};

export default function BlogSection() {
  const navigate = useNavigate();

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end gap-6 mb-12">
          <div className="lg:w-1/2">
            <span className="inline-block px-4 py-1.5 bg-background-200 rounded-full text-xs font-semibold text-foreground-700 mb-4 whitespace-nowrap">
              Artykuły SEO
            </span>
            <h2 className="font-heading text-4xl md:text-5xl font-bold text-foreground-900">
              Poradniki
              <br />
              <span className="italic text-foreground-600 font-normal">Kakobuy Spreadsheet</span>
            </h2>
          </div>
          <p className="lg:w-1/2 text-foreground-600 leading-relaxed text-sm md:text-base">
            Poznaj nasze szczegółowe poradniki i artykuły o Kakobuy Spreadsheet. Dowiedz się jak bezpiecznie zamawiać
            produkty z Chin, porównaj ceny wysyłki i sprawdź opinie innych użytkowników.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <a
              key={article.id}
              href={`/artykul/${article.slug}`}
              className="group block bg-background-100 rounded-2xl overflow-hidden cursor-pointer transition-all duration-300"
              onClick={(e) => {
                e.preventDefault();
                navigate(`/artykul/${article.slug}`);
                window.scrollTo({ top: 0, behavior: "instant" });
              }}
            >
              <div className="h-48 md:h-52 overflow-hidden">
                <img
                  src={articleImageUrls[article.id]}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <span className="inline-block px-2.5 py-0.5 bg-accent-100 text-accent-800 rounded-full text-xs font-semibold mb-3 whitespace-nowrap">
                  {article.category}
                </span>
                <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-2 group-hover:text-accent-700 transition-colors leading-snug">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-12 text-center">
          <a
            href="/poradnik-zakupowy"
            className="inline-flex items-center gap-2 bg-foreground-900 text-background-50 px-7 py-3 rounded-full text-sm font-semibold hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
            onClick={(e) => {
              e.preventDefault();
              navigate("/poradnik-zakupowy");
            }}
          >
            Zobacz wszystkie poradniki
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}